import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_LIST_TEAM_AND_ROLE_BY_USER = gql`
  query GetList($where: Map, $sort: Map) {
    GetTeamMemberList(
      pagination: { offset: 0, limit: 100, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on TeamMembers {
        data {
          id
          type
          team_id
          team {
            ... on Team {
              id
              name
              type
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
            }
          }
          user_id
          user {
            ... on User {
              id
              email
              name
            }
          }
          role_id
          role {
            ... on Role {
              id
              name
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
